// extracted by mini-css-extract-plugin
module.exports = {"menu":"MainMenu_menu__1Ez4Z","horizontal":"MainMenu_horizontal__jNPXA","stretch":"MainMenu_stretch__3BpF9","menuButton":"MainMenu_menuButton__3Ujw0"};